import { render, staticRenderFns } from "./PlatformIntro.vue?vue&type=template&id=83cd8916&scoped=true&"
import script from "./PlatformIntro.vue?vue&type=script&lang=js&"
export * from "./PlatformIntro.vue?vue&type=script&lang=js&"
import style0 from "./PlatformIntro.vue?vue&type=style&index=0&id=83cd8916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cd8916",
  null
  
)

export default component.exports